<template>
  <div>
    <h2>erpトップ</h2>
    <router-link to="/erp/settings">セッティング</router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  
}
</script>
